export * from './ports/types';
export { MockAudioSoundFx } from './mocks/mockAudioSoundFx';

export { AudioMixer, type AppEdition, type AudioMixerOptions } from './internal/AudioMixer';
export { PresetSoundSynthesizer, type PresetSoundType, type PresetSoundSynthesizerOptions } from './internal/PresetSoundSynthesizer';
export { CustomVoiceManager, type VoiceActionType, type VoiceSlotSummaryDTO, type VoiceBindingRecord, type CustomVoiceManagerOptions } from './internal/CustomVoiceManager';
export { PhysicsEventHandler, type PhysicsDomainEvent, type PhysicsEventHandlerOptions } from './internal/PhysicsEventHandler';
export { AudioSoundFxService, type AudioSoundFxServiceOptions } from './internal/AudioSoundFxService';

import { IAudioSoundFxPort } from './ports/types';
import { AudioSoundFxService, AudioSoundFxServiceOptions } from './internal/AudioSoundFxService';

/**
 * AudioSoundFxPort のファクトリ関数
 * 本番・プロトタイプ向けの本実装ファサード (AudioSoundFxService) を生成して返却
 */
export function createAudioSoundFxPort(options?: AudioSoundFxServiceOptions): IAudioSoundFxPort {
  return new AudioSoundFxService(options);
}
